<template>
  <div class="add-wrap">
    <Form :formData="formData" :topic_id="$route.params.id" :isEdit="true" />
  </div>
</template>

<script>
import Form from "./components/form.vue";

import {
  _topicSingleinfo //专题编辑
} from "@/api/topic";

export default {
  created() {
    // console.log(this.$route.params.id);
    this.topicSingleinfo();
  },
  data() {
    return {
      formData: {}
    };
  },
  components: {
    Form
  },
  methods: {
    //获取单条数据信息
    topicSingleinfo() {
      _topicSingleinfo({
        params: {
          topic_id: this.$route.params.id
        }
      }).then(res => {
        if (res.resultCode == 1) {
          this.formData = res.result;
        } else {
          this.$message.error(res.errorMsg);
        }
      });
    }
  }
};
</script>

<style lang="less">
</style>
